import lcmApiClient from "./lcmApiClient";
import { extractUserGroup } from "../extractors/userGroupsExtractor";

/* istanbul ignore next */
export async function createUserGroup(userGroup: $TSFixMe) {
  const newUserGroup = {
    name: userGroup.name,
    description: userGroup.description,
  };
  const response = await lcmApiClient().post("/usergroups", newUserGroup);
  return (response as $TSFixMe).id;
}

/* istanbul ignore next */
export async function updateUserGroup(id: $TSFixMe, userGroup: $TSFixMe) {
  const updatedUserGroup = {
    name: userGroup.name,
    description: userGroup.description,
  };
  await lcmApiClient().patch(`/usergroups/${id}`, updatedUserGroup);
}

/* istanbul ignore next */
export async function loadUserGroup(id: $TSFixMe, parameters: $TSFixMe) {
  // @ts-expect-error TS(2554) FIXME: Expected 3 arguments, but got 2.
  const response = await lcmApiClient(false).get(
    `/usergroups/${id}`,
    parameters,
  );
  return extractUserGroup(response);
}

/* istanbul ignore next */
export async function deleteUserGroup(id: $TSFixMe) {
  // @ts-expect-error TS(2554) FIXME: Expected 2-3 arguments, but got 1.
  return lcmApiClient().delete(`/usergroups/${id}`);
}
